export default "/images/dashboard-active-light.svg?2e7e3cb22d407d6f1f160a6936e85aa1";